import { Field } from 'redux-form';
import SelectTravellerNumber from '../../../fields/SelectTravellerNumber/SelectTravellerNumber';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { length, required } from 'redux-form-validators';
import TravelDates from '../../../TravelDates/TravelDates';
import CalculatedPremiumsField from '../../../CalculatedPremiumsField/CalculatedPremiumsField';
import { InfoButton } from '../../../../../../../../common/components';
import Declines from '../../../Declines/Declines';

const QuoteTab = ({
  calculatedPremiums,
  channelType,
  productRules,
  selectedSchemes,
  definitions,
  numTravellers,
  startDate,
  allErrors,
  isCalculating,
}) => {
  const selectedSchemeId = selectedSchemes?.[0]?.id;
  const selectedScheme = calculatedPremiums?.find(
    (premium) => premium.meta.scheme.id === selectedSchemeId,
  );
  const selectedPremium = selectedScheme?.meta;
  return (
    <div className={'sl-quote-tab'}>
      <Declines show={!!allErrors.length} errors={allErrors} />
      <Row>
        <Col xs={12}>
          {/* TODO: get from channel */}
          <div className={'tab-paragraph mb-30'}>
            A Smart Luggage policy will provide an automatic payment of £50 if your
            luggage is delayed and £500 if it is deemed lost, due to an airline or
            airport's mishandling of it. You (the policyholder) and each covered person
            can claim for one item of checked luggage on each leg of your trip.
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div className={'mb-15'}>
            How many individual travellers would you like Smart Luggage protection for?
            &nbsp; <InfoButton red content={definitions.traveller_info} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12} xs={12} lg={8} xl={6}>
          <Field
            name={'data.attributes.metadata.num_travellers'}
            component={SelectTravellerNumber}
            validate={required({ msg: 'Number of travellers is required' })}
            maxTravellers={productRules.max_travellers[channelType]}
          />
        </Col>
      </Row>
      {calculatedPremiums?.length > 0 && (
        <>
          <hr className={'hr-blue'} />
          <div className={'tab-heading'}>Quotes</div>

          <Field
            name={'data.relationships.schemes.data'}
            validate={length({ is: 1, msg: 'Please select at least one scheme' })}
            calculatedPremiums={calculatedPremiums}
            selectedSchemes={selectedSchemes}
            component={CalculatedPremiumsField}
            numTravellers={numTravellers}
            definitions={definitions}
            isCalculating={isCalculating}
          />
          {selectedPremium && (
            <Row className={'quote-tab-cover-dates-container'}>
              <hr className={'hr-blue'} />
              <div className={'tab-heading'}>
                Cover dates <InfoButton red content={definitions.travel_dates.single} />
              </div>
              <Col sm={12} xs={12} lg={8} xl={6}>
                <TravelDates
                  startDate={startDate}
                  selectedSchemeType={selectedPremium.scheme.scheme_type}
                  maxAdvanceDays={productRules.max_days_advance}
                  minAdvanceDays={productRules.min_days_advance}
                  maxDays={productRules.max_single_trip_days || 365}
                  minEndDate={startDate}
                  // singleDateDefinition={definitions.travel_dates.single}
                  // annualDateDefinition={definitions.travel_dates.annual}
                  tripTypeDefinition={definitions.trip_type}
                  validateStart={required({ msg: 'Start Date is required' })}
                  validateEnd={required({ msg: 'End Date is required' })}
                />
              </Col>
            </Row>
          )}
        </>
      )}
    </div>
  );
};

export default QuoteTab;
